const getInitialsFromParts = ({ parts = [], fallback = 'UU', max = 2 }) => {
	const initials = parts
		.map((part) => part?.trim()?.[0] || '')
		.filter(Boolean)
		.slice(0, max)
		.join('')
		.toUpperCase();

	return initials || fallback;
};

export const getAvatarInitials = ({ firstName, lastName, fallback = 'UU' }) =>
	getInitialsFromParts({
		parts: [firstName, lastName],
		fallback,
		max: 2,
	});

export const getCompanyInitials = ({ companyName, fallback = 'UU' }) =>
	getInitialsFromParts({
		parts: (companyName || '').trim().split(/\s+/).filter(Boolean),
		fallback,
		max: 2,
	});
